module.exports = __webpack_public_path__ + "img/18_105.9fb1b208.png";